const DYNAMIC_MENU_UID = "bde77e07-1845-4c87-bdf6-507583b5285d"

export { DYNAMIC_MENU_UID }